import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    private _storage: Storage | null = null;
    private _isReady = false;

    constructor(private storage: Storage) {}

    private async ensureInit() {
        if (!this._isReady) {
            this._storage = await this.storage.create();
            this._isReady = true;
        }
    }

    public async set(key: string, value: any) {
        await this.ensureInit();
        return await this._storage.set(key, value);
    }

    public async get(key: string) {
        await this.ensureInit();
        return await this._storage.get(key);
    }

    public async remove(key: string) {
        await this.ensureInit();
        return await this._storage.remove(key);
    }

    public async clear() {
        await this.ensureInit();
        return await this._storage.clear();
    }
}
